import MdaeDrawer from "./component";
import { IMenuOptions } from "devextreme-react/menu";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeMenuOption extends IMenuOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeDrawer;
